import { connect } from 'react-redux';
import { saveStep2 } from 'store/Guests/thunks';
import { closeModal } from 'store/Modal/actions';
import { RootState } from 'store/types';
import StepOptions from './StepOptions';

const mapStateToProps = (state: RootState) => ({
  language: state.params.lng,
  plansAndOptions: state.event.plansAndOptions.data,
});

export default connect(mapStateToProps, {
  saveStep2,
  closeModal,
})(StepOptions);
